// Constructor
function OUASVideos() {
  this.init();
}

OUASVideos.prototype.init = function () {

  var swiper = new Swiper('.swiper-container', {
    effect: 'coverflow',
    grabCursor: true,
    centeredSlides: true,
    slidesPerView: 'auto',
    coverflowEffect: {
      rotate: 50,
      stretch: 0,
      depth: 100,
      modifier: 1,
      slideShadows: true,
    },
    pagination: {
      el: '.swiper-pagination',
    },
  });

};

OUASVideos.prototype.reset = function () {

};

// Expose OUASVideos
window.OUASVideos = OUASVideos;

